// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-2UZpVnQW","title":"title-uoUMEx7f","list":"list-3tj8J1o0"};